import { IABTest } from '../../types';
import { IApplicationState } from '../../../types/types';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';
import { Dispatch, ThunkAction } from '../../../types/actions';
import {
    authUserSetOpenCardOnCreateSnackbarShowed
} from '../../../rest/effects/authUser/authUserSetOpenCardOnCreateSnackbarShowed';

export const AB_TEST_CARD_OPEN = 'AB_TEST_CARD_OPEN';
const AB_TEST_CARD_OPEN_SHOW = 'show';
const AB_TEST_CARD_OPEN_NOT_SHOW = 'not show';

const isRelevantChecker = (
    state: IApplicationState
): boolean => {
    const user = getAuthUser(state);
    const currentDateTimeStamp = new Date().getTime() / 1000;
    // аккаунт создан сегодня
    return (currentDateTimeStamp - user.createDateTimeStamp) <= 24 * 60 * 60;
}

const postProcessor = (
    value: string,
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        if (value === AB_TEST_CARD_OPEN_NOT_SHOW) {
            dispatch(authUserSetOpenCardOnCreateSnackbarShowed(true));
        }
    }
    return action;
}

export const getCardOpenConfig = (): IABTest => {
    return {
        name: AB_TEST_CARD_OPEN,
        defaultValue: AB_TEST_CARD_OPEN_SHOW,
        size: 1000,
        groups: [
            {
                weight: 100,
                value: AB_TEST_CARD_OPEN_SHOW
            },
            {
                weight: 100,
                value: AB_TEST_CARD_OPEN_NOT_SHOW
            }
        ],
        isRelevant: isRelevantChecker,
        executeOnLoad: true,
        postProcessor
    }
}
